import { DROPDOWN_PAGE, PagedResult, panelDelete, panelGet, panelPost, panelPut } from "./panel.api";
import { ProcurementApproach, Vendor, VendorPayload } from "./types";

/** vendor — /vendor */
export const vendorApi = {
  getAll: () => panelGet<Vendor[]>("/vendor", DROPDOWN_PAGE),
  getById: (id: string) => panelGet<Vendor>(`/vendor/${id}`),
  create: (payload: VendorPayload) => panelPost<Vendor>("/vendor", payload),
  update: (id: string, payload: VendorPayload) => panelPut<Vendor>(`/vendor/${id}`, payload),
  remove: (id: string) => panelDelete(`/vendor/${id}`),
  /** Vendors eligible for a region under a given procurement approach. */
  /**
   * The vendors a work order may go to. `category` (code or name) lets the
   * backend apply its category-aware rotation. The answer is
   * `{ editable, selectedVendor, vendors }` — older builds sent a bare list.
   */
  forProcurement: (regionId: string, procurementApproach: ProcurementApproach, category?: string) =>
    panelGet<any>("/vendor/procurement-vendors", { regionId, procurementApproach, category: category || undefined }),

  /**
   * Every vendor configured against a region.
   *
   * The paged route Manage Catalog reads, which demonstrably returns the
   * vendors an admin has set up. Used as the fallback when
   * `procurement-vendors` answers with nothing.
   */
  byRegion: (regionId: string) =>
    panelGet<PagedResult<Vendor>>("/vendor/get-vendor-list", {
      page: 0,
      size: 1000,
      orderBy: "vendorName",
      regionId,
    }),
};
